import initialStateMap from '../data/map'
import { 
  ZOOM_INCREMENT,
  ZOOM_DECREMENT,
  SET_BOUNDS,
  SET_CENTER_HEIGHT,
  SET_VIEWPORT,
  SET_SELECTED_OBJECT,
  SET_MODE,
  SET_SHOW_FORM,
  SET_CAMERA_IS_FLYING,
} from '../actions'

function map(state = initialStateMap, action) {
  switch (action.type) {
    case ZOOM_INCREMENT :
      return Object.assign({}, state, {
        zoom: state.zoom+1,
      })
    case ZOOM_DECREMENT :
      return Object.assign({}, state, {
        zoom: state.zoom-1,
      })
    case SET_BOUNDS :
      return Object.assign({}, state, {
        targetBounds: action.bounds,
        targetDuration: action.duration,
      })
    case SET_CENTER_HEIGHT :
      return Object.assign({}, state, {
        targetCenter: action.center,
        targetHeight: action.height,
        targetDuration: action.duration,
      })
    case SET_VIEWPORT :
      return Object.assign({}, state, {
        currentBounds: action.bounds,
        currentCenter: action.center,
        currentHeight: action.height,
        currentMagnitude: action.magnitude,
      })
    case SET_SELECTED_OBJECT :
      return Object.assign({}, state, {
        selectedObject: action.selectedObject,
      })
    case SET_MODE :
      return Object.assign({}, state, {
        mode: action.mode,
      })
    case SET_SHOW_FORM :
      return Object.assign({}, state, {
        showForm: action.showForm,
      })
    case SET_CAMERA_IS_FLYING :
      return Object.assign({}, state, {
        cameraIsFlying: action.cameraIsFlying,
      })
    default:
      return state
  }
}

export default map


// WEBPACK FOOTER //
// ./src/reducers/map.js